import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ChevronUp = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2605 34L24.4167 22.8678L35.573 34L39 30.5729L24.4167 15.9896L9.83337 30.5729L13.2605 34Z"
        fill={color}
      />
    </svg>
  )
}
